<template>
    <div class="accordion-item">
        <h3 class="accordion-header" id="strands-header">
            <button class="accordion-button d-flex" type="button" data-bs-toggle="collapse" data-bs-target="#strands-collapse" aria-expanded="true" aria-controls="strands-collapse">
                <span class="flex-grow-1">Strands</span>
                <span class="badge rounded-pill bg-primary me-2">{{ selected.length }}</span>
            </button>
        </h3>
        <div id="strands-collapse" class="accordion-collapse collapse" aria-labelledby="strands-header" data-bs-parent="#accordion-filter-options" ref="accbody">
            <div class="accordion-body">
                <multiselect
                    v-model="selected"
                    :options="strands"
                    :multiple="true"
                    placeholder="Select strands"
                    track-by="strand_hash"
                    label="strand"
                    @input="store"
                ></multiselect>
            </div>
        </div>
    </div>
</template>

<script>

import Multiselect from 'vue-multiselect';
import VueCookies from 'vue-cookies';

export default {
    components: { Multiselect, VueCookies },

    mounted() {
        this.$refs.accbody.addEventListener('show.bs.collapse', event => {
            this.load();
        });

        if (VueCookies.isKey('sr')) {
            this.selected = VueCookies.get('sr');
        }
    },

    data() {
        return {
            strands: [],
            selected: []
        }
    },

    methods: {
        load: function() {
            const data = this.$parent.poll();

            if (!data.areas.length || !data.grade_levels.length) {
                console.debug('Not enough information to find strands');
                return;
            }

            this.$parent.isLoading = true;
            
            axios
                .get('/api/strands', { params: data })
                .then(response => {
                    console.log(data);
                    console.log(response.data);
                    this.strands = response.data;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },

        store: function() {
            VueCookies.set('sr', this.selected, Infinity);
        },

        clear: function() {
            this.selected = [];
            this.store();
        }
    }
}
</script>